import Route from 'cio/routes/base';
import AuthService from 'cio/services/auth';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import RouterService from '@ember/routing/router-service';

export default class NewSnippetRoute extends Route {
  @service auth!: AuthService;
  @service router!: RouterService;

  crumb() {
    return {
      name: 'New',
      path: 'snippets.new',
    };
  }

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    if (Boolean(this.auth.hasPermission('journeys/snippets/create')) === false) {
      this.router.transitionTo('snippets.index');
      return;
    }
    return;
  }
}
